/**
 * Event location
 */
import Countries from "../utils/Countries";

export interface ILocation {
  online: boolean;
  country: string;
  city?: string | null;
}

export default class Location implements ILocation {
  readonly online: boolean;
  readonly country: string;
  readonly city?: string | null;

  constructor(props: ILocation) {
    this.online = props.online;
    this.country = props.country;
    this.city = props.city;
  }

  isWorldwide() {
    return this.country === '00' && this.online;
  }

  toString() {
    if (this.isWorldwide()) {
      return 'online';
    } else if (this.online) {
      return `${this.city}, ${Countries.getName(this.country)} (online)`;
    } else {
      return `${this.city}, ${Countries.getName(this.country)}`;
    }
  }
}
